import { type RootState } from '../../stores/redux';

export const getIsChatOpen = (state: RootState) => state.uiState.isChatOpen;

export const getActiveUserAccordionId = (state: RootState) =>
  state.uiState.activeUserAccordion;

export const getShouldSkipSidebarAutoOpenOnce = (state: RootState) =>
  state.uiState.shouldSkipSidebarAutoOpenOnce ?? false;

export const getActiveUserAccordionTabs = (state: RootState) =>
  state.uiState.activeUserAccordionTabs;

export const getActiveUserAccordionTab = (state: RootState) => {
  const userId = state.uiState.activeUserAccordion;
  return userId ? state.uiState.activeUserAccordionTabs[userId] : undefined;
};

export const getIsPictureInPictureStarted = (state: RootState) =>
  state.uiState.isPictureInPictureStarted;

export const getIsCallMenuOpen = (state: RootState) =>
  state.uiState.isCallMenuOpen ?? false;

export const getIsSelfPreviewExpanded = (state: RootState) =>
  state.uiState.isSelfPreviewExpanded ?? false;

export const getIsAnimationDisabled = (state: RootState) =>
  state.uiState.isAnimationDisabled ?? false;

export const getScrollTag = (state: RootState) => state.uiState.scrollTag;

export const getHasSeenAppsPopover = (state: RootState) =>
  state.uiState.hasSeenAppsPopover;

export const getChatFocusRequest = (state: RootState) =>
  state.uiState.chatFocusRequest;

export const getDialedPhoneNumber = (state: RootState) =>
  state.uiState.dialedPhoneNumber;
